/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const getCompany = /* GraphQL */ `
  query GetCompany($id: ID!) {
    getCompany(id: $id) {
      id
      name
      contact
      email
      status
      usage
      internalname
      groups
      VShits
      trackerhits
      durationhits
      alerthits
      agenthits
      sentimenthits
      topichits
      questionhits
      analyticshits
      alerts {
        items {
          id
          name
          agent
          conversation
          campaign
          groups
          risk
          readBy
          createdAt
          updatedAt
          companyAlertsId
        }
        nextToken
        __typename
      }
      trackers
      campaigns {
        items {
          id
          name
          startdate
          enddate
          active
          pinned
          VShits
          trackerhits
          durationhits
          alerthits
          agenthits
          sentimenthits
          topichits
          questionhits
          analyticshits
          trackers
          type
          groups
          createdAt
          updatedAt
          companyCampaignsId
        }
        nextToken
        __typename
      }
      agents {
        items {
          id
          name
          groups
          createdAt
          updatedAt
          companyAgentsId
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listCompanies = /* GraphQL */ `
  query ListCompanies(
    $filter: ModelCompanyFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCompanies(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        name
        contact
        email
        status
        usage
        internalname
        groups
        VShits
        trackerhits
        durationhits
        alerthits
        agenthits
        sentimenthits
        topichits
        questionhits
        analyticshits
        trackers
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getUser = /* GraphQL */ `
  query GetUser($id: ID!) {
    getUser(id: $id) {
      id
      firstname
      lastname
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const listUsers = /* GraphQL */ `
  query ListUsers(
    $filter: ModelUserFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listUsers(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        firstname
        lastname
        createdAt
        updatedAt
        owner
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getAlert = /* GraphQL */ `
  query GetAlert($id: ID!) {
    getAlert(id: $id) {
      id
      name
      agent
      conversation
      campaign
      company {
        id
        name
        contact
        email
        status
        usage
        internalname
        groups
        VShits
        trackerhits
        durationhits
        alerthits
        agenthits
        sentimenthits
        topichits
        questionhits
        analyticshits
        trackers
        createdAt
        updatedAt
        __typename
      }
      groups
      risk
      readBy
      createdAt
      updatedAt
      companyAlertsId
      __typename
    }
  }
`;
export const listAlerts = /* GraphQL */ `
  query ListAlerts(
    $filter: ModelAlertFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listAlerts(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        name
        agent
        conversation
        campaign
        groups
        risk
        readBy
        createdAt
        updatedAt
        companyAlertsId
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getAgent = /* GraphQL */ `
  query GetAgent($id: ID!) {
    getAgent(id: $id) {
      id
      name
      company {
        id
        name
        contact
        email
        status
        usage
        internalname
        groups
        VShits
        trackerhits
        durationhits
        alerthits
        agenthits
        sentimenthits
        topichits
        questionhits
        analyticshits
        trackers
        createdAt
        updatedAt
        __typename
      }
      groups
      campaigns {
        nextToken
        __typename
      }
      conversation {
        nextToken
        __typename
      }
      sftpProcess {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      companyAgentsId
      __typename
    }
  }
`;
export const listAgents = /* GraphQL */ `
  query ListAgents(
    $filter: ModelAgentFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listAgents(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        name
        groups
        createdAt
        updatedAt
        companyAgentsId
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getCampaign = /* GraphQL */ `
  query GetCampaign($id: ID!) {
    getCampaign(id: $id) {
      id
      name
      startdate
      enddate
      active
      pinned
      VShits
      trackerhits
      durationhits
      alerthits
      agenthits
      sentimenthits
      topichits
      questionhits
      analyticshits
      trackers
      type
      direction
      company {
        id
        name
        contact
        email
        status
        usage
        internalname
        groups
        VShits
        trackerhits
        durationhits
        alerthits
        agenthits
        sentimenthits
        topichits
        questionhits
        analyticshits
        trackers
        createdAt
        updatedAt
        __typename
      }
      conversations {
        nextToken
        __typename
      }
      agents {
        nextToken
        __typename
      }
      groups
      s3Key
      createdAt
      updatedAt
      companyCampaignsId
      __typename
    }
  }
`;
export const listCampaigns = /* GraphQL */ `
  query ListCampaigns(
    $filter: ModelCampaignFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCampaigns(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        name
        startdate
        enddate
        active
        pinned
        VShits
        trackerhits
        durationhits
        alerthits
        agenthits
        sentimenthits
        topichits
        questionhits
        analyticshits
        trackers
        type
        direction
        groups
        s3Key
        createdAt
        updatedAt
        companyCampaignsId
        company {
          id
          name
          contact
          email
          status
          usage
          internalname
          groups
          VShits
          trackerhits
          durationhits
          alerthits
          agenthits
          sentimenthits
          topichits
          questionhits
          analyticshits
          trackers
          createdAt
          updatedAt
        }
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getConversation = /* GraphQL */ `
  query GetConversation($id: ID!) {
    getConversation(id: $id) {
      id
      name
      agent
      agenttag
      archive
      startdate
      sentiment
      enddate
      bookmarks
      duration
      VS
      symblstatus
      symbljobid
      symblconversationid
      alertcount
      transcript
      topics
      analytics
      questions
      summary
      trackersdetected
      file
      campaign {
        id
        name
        startdate
        enddate
        active
        pinned
        VShits
        trackerhits
        durationhits
        alerthits
        agenthits
        sentimenthits
        topichits
        questionhits
        analyticshits
        trackers
        type
        direction
        groups
        s3Key
        createdAt
        updatedAt
        companyCampaignsId
        __typename
      }
      groups
      s3Key
      message
      agentId {
        id
        name
        groups
        createdAt
        updatedAt
        companyAgentsId
        __typename
      }
      createdAt
      updatedAt
      agentConversationId
      campaignConversationsId
      __typename
    }
  }
`;
export const listConversations = /* GraphQL */ `
  query ListConversations(
    $filter: ModelConversationFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listConversations(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        name
        agent
        agenttag
        archive
        startdate
        sentiment
        enddate
        bookmarks
        duration
        VS
        symblstatus
        symbljobid
        symblconversationid
        alertcount
        transcript
        topics
        analytics
        questions
        summary
        trackersdetected
        file
        campaign {
          id
          name
          startdate
          enddate
          active
          pinned
          VShits
          trackerhits
          durationhits
          alerthits
          agenthits
          sentimenthits
          topichits
          questionhits
          analyticshits
          trackers
          type
          groups
          createdAt
          updatedAt
          companyCampaignsId
        }
        groups
        s3Key
        message
        createdAt
        updatedAt
        agentConversationId
        campaignConversationsId
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getTopic = /* GraphQL */ `
  query GetTopic($id: ID!) {
    getTopic(id: $id) {
      id
      conversation_id
      topic
      topics_with_sentiment
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listTopics = /* GraphQL */ `
  query ListTopics(
    $filter: ModelTopicFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listTopics(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        conversation_id
        topic
        topics_with_sentiment
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getSFTPProcessQueue = /* GraphQL */ `
  query GetSFTPProcessQueue($id: ID!) {
    getSFTPProcessQueue(id: $id) {
      id
      agentId {
        id
        name
        groups
        createdAt
        updatedAt
        companyAgentsId
        __typename
      }
      conversationId
      campaignKey
      createdAt
      endProcessTime
      fileName
      hitType
      processed
      queuedForProcessing
      s3Key
      startProcessTime
      updatedAt
      metaData {
        nextToken
        __typename
      }
      agentSftpProcessId
      __typename
    }
  }
`;
export const listSFTPProcessQueues = /* GraphQL */ `
  query ListSFTPProcessQueues(
    $filter: ModelSFTPProcessQueueFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listSFTPProcessQueues(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        conversationId
        campaignKey
        createdAt
        endProcessTime
        fileName
        hitType
        processed
        queuedForProcessing
        s3Key
        startProcessTime
        updatedAt
        agentSftpProcessId
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getMetaDataRelatedToSFTPFile = /* GraphQL */ `
  query GetMetaDataRelatedToSFTPFile($id: ID!) {
    getMetaDataRelatedToSFTPFile(id: $id) {
      id
      recordingId
      campaignName
      teamName
      sftpId {
        id
        conversationId
        campaignKey
        createdAt
        endProcessTime
        fileName
        hitType
        processed
        queuedForProcessing
        s3Key
        startProcessTime
        updatedAt
        agentSftpProcessId
        __typename
      }
      direction
      customerId
      callDate
      startTime
      endTime
      durationInSec
      endedBy
      outcomeName
      createdAt
      updatedAt
      sFTPProcessQueueMetaDataId
      __typename
    }
  }
`;
export const listMetaDataRelatedToSFTPFiles = /* GraphQL */ `
  query ListMetaDataRelatedToSFTPFiles(
    $filter: ModelMetaDataRelatedToSFTPFileFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listMetaDataRelatedToSFTPFiles(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        recordingId
        campaignName
        teamName
        direction
        customerId
        callDate
        startTime
        endTime
        durationInSec
        endedBy
        outcomeName
        createdAt
        updatedAt
        sFTPProcessQueueMetaDataId
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getAgentsandcampaigns = /* GraphQL */ `
  query GetAgentsandcampaigns($id: ID!) {
    getAgentsandcampaigns(id: $id) {
      id
      agentId
      campaignId
      agent {
        id
        name
        groups
        createdAt
        updatedAt
        companyAgentsId
        __typename
      }
      campaign {
        id
        name
        startdate
        enddate
        active
        pinned
        VShits
        trackerhits
        durationhits
        alerthits
        agenthits
        sentimenthits
        topichits
        questionhits
        analyticshits
        trackers
        type
        direction
        groups
        s3Key
        createdAt
        updatedAt
        companyCampaignsId
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listAgentsandcampaigns = /* GraphQL */ `
  query ListAgentsandcampaigns(
    $filter: ModelAgentsandcampaignsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listAgentsandcampaigns(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        agentId
        campaignId
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const conversationBySConversationId = /* GraphQL */ `
  query ConversationBySConversationId(
    $symbljobid: String!
    $sortDirection: ModelSortDirection
    $filter: ModelConversationFilterInput
    $limit: Int
    $nextToken: String
  ) {
    conversationBySConversationId(
      symbljobid: $symbljobid
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        name
        agent
        agenttag
        archive
        startdate
        sentiment
        enddate
        bookmarks
        duration
        VS
        symblstatus
        symbljobid
        symblconversationid
        alertcount
        transcript
        topics
        analytics
        questions
        summary
        trackersdetected
        file
        groups
        s3Key
        message
        createdAt
        updatedAt
        agentConversationId
        campaignConversationsId
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const agentsandcampaignsByAgentId = /* GraphQL */ `
  query AgentsandcampaignsByAgentId(
    $agentId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelAgentsandcampaignsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    agentsandcampaignsByAgentId(
      agentId: $agentId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        agentId
        campaignId
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const agentsandcampaignsByCampaignId = /* GraphQL */ `
  query AgentsandcampaignsByCampaignId(
    $campaignId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelAgentsandcampaignsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    agentsandcampaignsByCampaignId(
      campaignId: $campaignId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        agentId
        campaignId
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
